export default "__VITE_ASSET__45a6b49a__"